import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GD_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GD_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 6h20v12H6V6z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GD_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 6,
      y: 6,
      width: 20,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 6h20v12H6V6z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GD_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 6l10 6-10 6V6zM26 6l-10 6 10 6V6z",
      fill: "#23875F"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GD_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 16,
      y: 6,
      width: 10,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 6l-10 6 10 6V6z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 16a4 4 0 100-8 4 4 0 000 8z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.93 13.313l-2.072 1.437.662-2.46L13 10.718l2.059-.085.87-2.433.871 2.433h2.055L17.34 12.29l.76 2.315-2.17-1.292z",
      fill: "#FECA00"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.776 4.442l1.132-.702 1.185.631-.415-1.13.829-.81h-1.123l-.476-1.189-.476 1.189-1.125.041.83.768-.361 1.202zm6 0l1.132-.702 1.185.631-.415-1.13.829-.81h-1.123l-.476-1.189-.476 1.189-1.125.041.83.768-.361 1.202zm7.132-.702l-1.132.702.361-1.202-.83-.768 1.125-.041.476-1.189.476 1.189h1.123l-.83.81.416 1.13-1.185-.63zM8.776 22.168l1.132-.702 1.185.63-.415-1.13.829-.81h-1.123l-.476-1.188-.476 1.188-1.125.042.83.768-.361 1.202zm7.132-.702l-1.132.702.361-1.202-.83-.768 1.125-.042.476-1.188.476 1.188h1.123l-.83.81.416 1.13-1.185-.63zm4.868.702l1.132-.702 1.185.63-.415-1.13.829-.81h-1.123l-.476-1.188-.476 1.188-1.125.042.83.768-.361 1.202z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.635 12.772s.538.48.832.643c.1-.384-.125-1.252-.125-1.252-.063-.208-.758-.58-.758-.58s-.195.655.05 1.189z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.196 13.93s-1.383-.646-1.524-1.56c-.14-.913.158-2.37.158-2.37s2.246.511 2.399 1.606c.152 1.096-.355 1.784-.355 1.784s-.52-1.335-1.01-1.484c0 0 0 1.324.332 2.024z",
      fill: "#FECA00"
    }
  ))
);
export {
  t as default
};
